import { useState } from "react";
import api, { formatApiErrorDetail } from "../lib/api";
import { PageHeader } from "../components/Section";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Mail, MapPin, Phone } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent. Shalom!");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed to send");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="contact-page">
      <PageHeader eyebrow="REACH OUT" title="Contact the Council"
        subtitle="We'd love to hear from you — for prayer, questions, or a first visit." />
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="font-display text-2xl text-white mb-6">Council House</h3>
            <ul className="space-y-4 text-zinc-300">
              <li className="flex gap-3"><MapPin className="w-5 h-5 text-gold mt-0.5" /> Council House, Accra, Ghana</li>
              <li className="flex gap-3"><Phone className="w-5 h-5 text-gold mt-0.5" /> +233 20 000 0000</li>
              <li className="flex gap-3"><Mail className="w-5 h-5 text-gold mt-0.5" /> hello@ayshammah.org</li>
            </ul>
            <div className="mt-10 border hairline rounded-xl p-6 surface">
              <div className="font-accent text-xs text-gold mb-3">SABBATH SERVICE</div>
              <p className="text-zinc-300">Every Saturday · 10:00 AM</p>
            </div>
          </div>
          <form onSubmit={submit} className="border hairline rounded-xl p-8 surface space-y-5" data-testid="contact-form">
            <div>
              <Label htmlFor="name" className="text-zinc-300">Full name</Label>
              <Input id="name" data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-2 bg-black/40 border-zinc-800" />
            </div>
            <div>
              <Label htmlFor="email" className="text-zinc-300">Email</Label>
              <Input id="email" data-testid="contact-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2 bg-black/40 border-zinc-800" />
            </div>
            <div>
              <Label htmlFor="subject" className="text-zinc-300">Subject</Label>
              <Input id="subject" data-testid="contact-subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="mt-2 bg-black/40 border-zinc-800" />
            </div>
            <div>
              <Label htmlFor="message" className="text-zinc-300">Message</Label>
              <Textarea id="message" data-testid="contact-message" required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-2 bg-black/40 border-zinc-800" />
            </div>
            <Button type="submit" data-testid="contact-submit" disabled={submitting} className="w-full bg-gold text-black hover:bg-slate-200">
              {submitting ? "Sending…" : "Send Message"}
            </Button>
          </form>
        </div>
      </section>
    </div>
  );
}
